import { useAppSelector } from '../store/hooks';
import { defaultRoutesByRole, rolePath, type AppRole } from './paths';
import { resolveAppRole } from './resolveAppRole';

export function useAppRole(): AppRole {
  return useAppSelector((state: any) =>
    resolveAppRole(state.authorization?.user, state.roles?.roles),
  );
}

export function useRolePath() {
  const role = useAppRole();
  return (pagePath: string) => rolePath(role, pagePath);
}

export function useDefaultHomePath() {
  const role = useAppRole();
  return defaultRoutesByRole[role];
}
